import React from 'react';
import HeroBookDemoCta from './HeroBookDemoCta';
import HeroBrandLogo from './HeroBrandLogo';
import HeroTypewriterTitle from './HeroTypewriterTitle';
import '../hero/HeroSection.css';
import './TeamHeroSection.css';

const TeamHeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-bg" aria-hidden="true">
      <img src="/images/hero_lummo.png" alt="" loading="eager" className="hero-bg-img" />
      <div className="hero-vignette" />
    </div>
    <div className="hero-container">
      <div className="hero-inner">
        <HeroTypewriterTitle text="Building the Future of Trials in LATAM" />
        <p className="hero-subtitle">We are founders, clinicians, and operators united by one conviction: clinical innovation must reach the people who need it most.</p>
        <HeroBookDemoCta />
        <HeroBrandLogo />
      </div>
    </div>
    <div className="scroll-indicator" aria-hidden="true">
      <span className="scroll-dot" />
    </div>
  </section>
);
export default TeamHeroSection;
